import React, { useState } from "react";
import { BsEnvelope } from "react-icons/bs";
import { Link } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";
import Logo from "../../components/Logo";
function SendLink() {
  // state to check if email sent
  const [emailSent, sendingEmail] = useState(0);
  function openDialog() {
    sendingEmail(!emailSent);
  }
  // styles
  const style = {
    loginBtn:
      "w-full bg-indigo-500 text-white px-4 py-3 rounded hover:bg-indigo-600  mr-4 font-medium text-xs flex flex-row",
    field: {
      parentDiv:
        "border border-indigo-200 focus-within:bg-indigo-50  py-3 px-3 rounded flex flex-row  focus-within:border-indigo-500",
      input: "h-full w-4/5 focus:outline-none bg-transparent",
      icon: "m-auto ml-0 mr-1 hidden",
    },
  };
  return (
    <AuthLayout>
      <div className="flex flex-col text-white m-auto min-h-full w-full">
        <Link className="py-3 m-auto mb-2 text-white" to="/">
          <Logo />
        </Link>
        {/* Login form */}
        <div
          className={
            emailSent
              ? "hidden"
              : "bg-white rounded p-10 text-gray-500  flex flex-col m-auto mt-2"
          }
        >
          <div className="w-64">
            <h2 className="font-semibold text-xs">Change current password</h2>
            <div className="py-1 text-xs">
              <p className="text-gray-600">
                We will use your email,to send you a recovery link.
              </p>
              {/* username field */}
              <div className="py-2">
                <label>Email </label>
                <div className={style.field.parentDiv}>
                  <BsEnvelope className={style.field.icon} />
                  <input
                    type="email"
                    placeholder="Andika imeri yawe"
                    className={style.field.input}
                  />
                </div>
              </div>

              {/* login btn */}
              <button
                type="submit"
                className={style.loginBtn}
                onClick={() => openDialog()}
              >
                <p className="m-auto">Send</p>
              </button>
              <div className="flex">
                <Link to={"/"} className="m-auto my-3 text-indigo-500 font-medium hover:text-indigo-300">
                  Return to login
                </Link>
              </div>
            </div>
            {/* signup info */}
          </div>
        </div>
        {/* Login form */}
        <div
          className={
            !emailSent
              ? "hidden"
              : "bg-white rounded p-10 text-gray-500  flex flex-col m-auto"
          }
        >
          <div className="w-64 text-center">
            <h2 className="font-semibold text-xs">Change password</h2>
            <div className="py-1 text-xs">
              <p className="text-gray-600 py-1">
                We have send link to email{" "}
                <span className="text-indigo-500 cursor-pointer font-medium mr-1">
                  hyassin23@gmail.com
                </span>
                that will help you to change your password
              </p>
              <p className="text-gray-600 py-1">
                Don't get it,
                <Link
                  className="text-indigo-500 hover:text-indigo-600 cursor-pointer ml-1 font-medium"
                  to="#"
                >
                  Resend Link
                </Link>
              </p>
              {/* login btn */}
              <button
                type="submit"
                className={style.loginBtn}
                onClick={() => openDialog()}
              >
                <p className="m-auto">Use another email</p>
              </button>
            </div>
            {/* signup info */}
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}

export default SendLink;
